module.exports = __webpack_public_path__ + "img/banners-safari-mobile.1a8d08a8.png";